module.exports = __webpack_public_path__ + "img/Orb_Label_Text_Language.9aa41e59.png";